import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MenuItemContent = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
});

export const MenuItemRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  width: "100%",
});

export const OptionIconImg = styled("img")({
  width: 16,
  height: 16,
  flexShrink: 0,
  borderRadius: "50%",
  objectFit: "cover",
});
